export default __webpack_public_path__ + "static/media/empty_main_image.1f8c3947.svg";